import React from "react";
import { connect } from 'react-redux';

class MDSubBanner extends React.Component {
    render() {
        const { SubBannerTitle } = this.props;
        return (
            <div>
                {SubBannerTitle !== "" ? (
                    <div className="sub-banner sub-banner-height" style={{ width: "100%" }}>
                        <div className="row w-100">
                            <div className="col-sm-12">
                                <ul id="nav">
                                    <li>
                                        <div className="page-head">
                                            <h2>{SubBannerTitle}</h2>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        SubBannerTitle: state.SidePanReducer.SubBannerTitle || 'Dashboard'
    }
}

export default connect(mapStateToProps, null)(MDSubBanner);